export enum API_CODES {
  OK = '00000', // 성공
  NO_CONTENT = '40401', // 존재하지 않는 데이터
  BAD_REQUEST = '40001', // 파라미터 오류
  REQUEST_ERROR = '40002', // 요청 메시지 오류
  UNAUTHORIZED = '40101', // 권한오류
  NOT_FOUND = '40402', // 존재하지 않는 URI
  METHOD_NOT_ALLOWED = '40501', // 허용되지 않는 메소드
  INTERNAL_SERVER_ERROR = '50001', // 서버 오류
  SERVICE_UNAVAILABLE = '50301', // 서비스 이용 불가
}

export type API_RESPONSE<T> =
  | ({
    code: API_CODES.OK | API_CODES.NO_CONTENT;
    message: string;
  } & T)
  | {
    code: Exclude<API_CODES, API_CODES.OK | API_CODES.NO_CONTENT>;
    message: string;
  };

export type ScheduleItem = {
  day_week: string;
  class_period: string;
  subject_name: string;
  classroom_name: string;
  school_name: string;
  lecture_code: string;
};

export type TeacherScheduleResponse = API_RESPONSE<{
  schedule_info: ScheduleItem[];
}>;
export type StudentScheduleResponse = API_RESPONSE<{
  schedule_info: ScheduleItem[];
}>;

export interface MemberInfo {
  user_id: string;
  user_name: string;
  user_number: string;
}

export interface MemberInfoResponse {
  member_info: MemberInfo[];
}

export type TeacherClassMembersResponse = API_RESPONSE<MemberInfoResponse>;

export type UserNamesResponse = API_RESPONSE<{
  user_list: {
    user_id: string;
    user_name: string;
  }[];
}>;
export interface TeacherOpenSubjectInfo {
  user_id: string; // 교사 UUID
  user_name: string; // 교사 성명
  user_division: string; // 학교구분코드 (2:초등, 3:중등, 4:고등)
  school_id: string; // 학교 ID
  school_name: string; // 학교명
  user_grade: string; // 학년
  user_order: string; // 계열
  user_subject: string; // 학과
  user_dyng: string; // 주야구분
  user_class: string; // 반
  lecture_room_code: string; // 강의실 코드
  lecture_room_name: string; // 강의실명
  subject_name: string; // 과목명
  api_version: string; // API 버전
}

export type TeacherOpenSubjectInfoResponse = API_RESPONSE<TeacherOpenSubjectInfo>;

export type MySchoolNameResponse = API_RESPONSE<{
  school_name: string;
}>;
